import React, { useContext, useEffect, useRef, useState } from 'react';

// nav icon — Patek Philippe emblem (replaces Hermes H wings)
import wingLeft from "../../_asset/image/logo/patek-philippe-logo.png"
import wingRight from "../../_asset/image/logo/patek-philippe-logo.png"

import { PageModalContext } from "../../apps/providers";
import { DeviceWidthContext, UserContext } from "../../apps/_root";
import api from '../../util/api';
import swal from "sweetalert"

// nav obj
export interface navListInterface {
    img?: string,
    text: string,
}
export const navList: navListInterface[] = [
    {
        text: "슬롯머신"
    },
    {
        text: "카지노"
    },
    {
        text: "홀덤"
    },
    {
        text: "미니게임"
    },
    {
        text: "입금신청"
    },
    {
        text: "출금신청"
    },
    {
        text: "공지사항"
    },
    {
        text: "마이페이지"
    },
]

function HeaderNavigation() {
    const { LoginFailed, UserAuthCheck } = useContext(UserContext)
    const { SetPageModalShow, SetMenuType, SetPageName } = useContext(PageModalContext)

    function getHoldemURL() {
        api(`/api/game/games/link/realpoker`)
            .then(res => res.json())
            .then((data: { link: string }) => {
                if (data?.link) {
                    window.open(data.link, 'holdem pop', 'width=1200 height=640')
                }
            })
            .catch((res: Response) => {
                ErrorHandler(res)
            })
    }
    async function ErrorHandler(res: Response) {
        const message = await res.json()
        swal({
            text: message,
            icon: "error"
        })
    }

    return (
        <>
            <MobileNav UserAuthCheck={UserAuthCheck}
                LoginFailed={LoginFailed} />
            <nav className={'header-nav'}>
                <ul className={'menu-animation'}>
                    {
                        navList.map((nav, index) => {
                            if (index < 4) {
                                return (
                                    <li key={index}
                                        onClick={e => {
                                            UserAuthCheck(() => {
                                                if (nav.text == '홀덤') {
                                                    getHoldemURL()
                                                } else {
                                                    SetMenuType('game')
                                                    SetPageName(nav.text)
                                                    SetPageModalShow(true)
                                                }
                                            })
                                        }}>
                                        <span className="icon-wrap left"><img src={wingLeft} className="icon left" /></span>
                                        <p>{nav.text}</p>
                                        <span className="icon-wrap right"><img src={wingRight} className="icon right" /></span>
                                    </li>
                                )
                            }
                        })
                    }
                </ul>
                <ul className={'menu-animation'}>
                    {
                        navList.map((nav, index) => {
                            if (index > 3) {
                                return (
                                    <li key={index}
                                        onClick={e => {
                                            UserAuthCheck(() => {
                                                if (nav.text == '홀덤') {
                                                    getHoldemURL()
                                                } else {
                                                    SetMenuType('game')
                                                    SetPageName(nav.text)
                                                    SetPageModalShow(true)
                                                }
                                            })
                                        }}>
                                        <span className="icon-wrap left"><img src={wingLeft} className="icon left" /></span>
                                        <p>{nav.text}</p>
                                        <span className="icon-wrap right"><img src={wingRight} className="icon right" /></span>
                                    </li>
                                )
                            }
                        })
                    }
                </ul>
            </nav>
        </>
    );
}

export default HeaderNavigation;

function MobileNav({ UserAuthCheck, LoginFailed }: { UserAuthCheck: Function, LoginFailed: Function }) {
    const { mobileMode } = useContext(DeviceWidthContext)
    const [navShow, setNavShow] = useState<boolean>(false)
    const { SetPageModalShow, SetMenuType, SetPageName } = useContext(PageModalContext)

    function handleClose() {
        setNavShow(false)
    }
    useEffect(() => {
        if (!mobileMode) {
            handleClose()
        }
    }, [mobileMode])
    return (
        <div className={'mobile-menu-layout'}>
            <div className={`mobile-ham ${navShow ? "active" : ""}`}
                onClick={e => setNavShow(!navShow)}
            >
                <span className={'ham-bar'}></span>
                <span className={'ham-bar'}></span>
                <span className={'ham-bar'}></span>
            </div>
            <div className={`mobile-modal ${navShow ? "active" : ""}`}
                onClick={e => setNavShow(false)}
            ></div>
            <nav className={`mobile-nav ${navShow ? "active" : ""}`}>
                <ul>
                    {
                        navList.map((nav, index) => (
                            <li key={index}
                                onClick={e => {
                                    UserAuthCheck(() => {
                                        SetMenuType('board')
                                        SetPageName(nav.text)
                                        SetPageModalShow(true)
                                    })
                                }}>
                                <p>{nav.text}</p>
                            </li>
                        ))
                    }
                </ul>
            </nav>
        </div>
    )
}